import { useState, useEffect } from 'react';
import axios from 'axios';
// import types if needed, or use plain JS objects

const API_BASE_URL = process.env.REACT_APP_API_URL;

const normalizeMessageContent = (content) => {
    return content.map(item => {
        if (item.value && typeof item.value === 'object' && 'type' in item.value) {
            return {
                type: item.value.type,
                value: item.value.value,
                language: item.value.language,
                metadata: item.value.metadata,
                convoId: item.convoId
            };
        }
        return {
            type: item.type || 'text',
            value: item.value,
            language: item.language,
            metadata: item.metadata,
            convoId: item.convoId
        };
    });
};

export default function useConversations() {
    const [conversations, setConversations] = useState([]);
    const [currentConversation, setCurrentConversation] = useState(null);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        async function loadConversations() {
            const res = await axios.get(`${API_BASE_URL}/api/conversations`, {
                headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
            });
            const normalizedConversations = res.data.map(conv => ({
                ...conv,
                messages: conv.messages.map(msg => ({
                    ...msg,
                    content: normalizeMessageContent(msg.content)
                }))
            }));
            setConversations(normalizedConversations);
            if (normalizedConversations.length) await switchConv(normalizedConversations[0].id);
        }
        loadConversations();
    }, []);

    async function create() {
        const res = await axios.post(`${API_BASE_URL}/api/conversations`,
            { title: 'New Conversation' },
            { headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` } }
        );
        setConversations(prev => [res.data, ...prev]);
        await switchConv(res.data.id);
    }

    async function switchConv(id) {
        const res = await axios.get(`${API_BASE_URL}/api/conversations/${id}`, {
            headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
        });
        const normalizedConversation = {
            ...res.data,
            messages: res.data.messages.map(msg => ({
                ...msg,
                content: normalizeMessageContent(msg.content)
            }))
        };
        setCurrentConversation(normalizedConversation);
        setMessages(normalizedConversation.messages);
    }

    function addMessage(role, content, metadata) {
        const normalizedContent = normalizeMessageContent(content);
        setMessages(prev => {
            const updated = [...prev, { role, content: normalizedContent, metadata }];
            return updated;
        });
    }

    function clearConversationMessages() {
        setMessages([]);
    }

    return {
        conversations,
        currentConversation,
        messages,
        createNewConversation: create,
        switchConversation: switchConv,
        addMessage,
        clearConversationMessages,
    };
} 